import React, { PropsWithChildren, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { openDialog } from "../../store/actions";

interface IProps extends PropsWithChildren<any> {
  dialogOptions?: any;
  getDialogOptions?: () => object;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions))
});

const connector = connect(null, mapDispatchToProps);

const DialogButton = ({
  dialogOptions,
  getDialogOptions,
  children,
  openDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const buttonRef = useRef<HTMLAnchorElement>(null);

  return (
    <a
      ref={buttonRef}
      className="btn btn-blank"
      onClick={() => openDialogDispatch({
        ...(dialogOptions || (getDialogOptions && getDialogOptions())),
        elementRef: buttonRef.current
      })}
    >
      {children}
    </a>
  )
}

export default connector(DialogButton);
